import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import PagePreloader from '@/Components/navigation/PagePreloader';

/**
 * Protege rotas /admin/*: exige usuario autenticado E is_admin=true.
 * Equivalente ao meta.requiresAdmin do router Vue.
 */
export function AdminRoute() {
  const { isAuthenticated, isAdmin, loading, postLoginRoute } = useAuth();

  if (loading) {
    return <PagePreloader active={true} />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return <Navigate to={postLoginRoute} replace />;
  }

  return <Outlet />;
}
